import { FC, useState } from 'react';
import React from 'react';
import { Registration } from '../../../../types/registrationTypes';
import SystemForm from './containers/systemForm';
import useIsMounted from '../../../../hooks/useIsMounted';

interface Props {
  registration?: Registration | null;
  updateRegistration: (registration: Registration) => Promise<Registration>;
  preventSwitchTabDueToUnsavedData: (value: boolean) => void;
  disabled: boolean;
}

const RegistrationSystem: FC<Props> = ({ registration, updateRegistration, preventSwitchTabDueToUnsavedData, disabled }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const isMounted = useIsMounted();

  const updateHeatingSetup = async (heatingSetup: Registration['heatingSetup']) => {
    setLoading(true);
    try {
      await updateRegistration({
        ...registration!,
        heatingSetup: heatingSetup
      });
    } catch (error) {
      throw error;
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  };

  return (
    <SystemForm
      disabled={disabled}
      heatingSetup={registration?.heatingSetup}
      loading={loading}
      updateRegistration={updateHeatingSetup}
      preventSwitchTabDueToUnsavedData={preventSwitchTabDueToUnsavedData}
    />
  );
};

export default RegistrationSystem;
